import React from 'react';
import GolfSoloBookingConfirmDetailContainer from '../organisms/golfSoloBookingConfirmDetailContainer';
import { GolfSoloHeaderContainer } from '../organisms/golfSoloHeaderContainer';
import GolfSoloReservationPopupContainer from '../organisms/golfSoloReservationPopupContainer';
import GolfSoloCancelPopup from '../organisms/golfSoloCancelPopup';


class GolfSoloBookingConfirmDetailTemplate extends React.Component {

    render() {
        return (
            <>
                <GolfSoloHeaderContainer
                    categoryLabel1={"予約内容確認"}
                    categoryLabel2={"CONFIRM"}
                    path={"/reserve/golf/soloSearch"}
                    bookedConfirmLabel={"予約確認"}
                    onClickOpenReservationPopupWindow={this.props.onClickOpenReservationPopupWindow}
                />
                <GolfSoloBookingConfirmDetailContainer
                    state={this.props.state}
                    onClickOpenCalendarWindow={this.props.onClickOpenCalendarWindow}
                    onClickOpenCancelPopupWindow={this.props.onClickOpenCancelPopupWindow}
                />
                <GolfSoloReservationPopupContainer
                    state={this.props.state}
                    onClickClosePopupWindow={this.props.onClickClosePopupWindow}
                />
                <GolfSoloCancelPopup
                    state={this.props.state}
                    onClickCloseCancelPopupWindow={this.props.onClickCloseCancelPopupWindow}
                />
            </>
        )
    }
}
export default GolfSoloBookingConfirmDetailTemplate;